import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Spinner, Badge, Button,
  Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input,
} from 'reactstrap'
import moment from 'moment'
import powerAppsApi from '../../../services/powerapps';
import { currencyFormatter } from '../../../utils/currencyFormatter'
import AddContract from '../../../components/Modal/AddContract'
import AddDraftContract from '../../../components/Modal/AddDraftContract'
import DataTable from '../../../components/Template/Table/DataTable'
import Select from '../../../components/Template/Input/Select'
import DatePicker from 'react-datepicker'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { listProposals, getDraftContracts } from '../../../store/ducks/comercial'
import oikosApi from '../../../services/oikos/index';
import endPoints1Api from '../../../services/end_points_1';
import qs from 'qs';
import { c } from 'tar'
import {MaterialReactTable} from 'material-react-table'
import { access } from 'graceful-fs'
import { notifyError, notifySuccess } from '../../../utils/notify'
import { blur } from 'redux-form'
import { TextareaAutosize } from '@mui/material'
import Edit from '@material-ui/icons/Edit'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'

const statusCodeMap = {
  'Em contratação': ['UC_IXBSS5', 'C14:UC_3AVN8G'],
  'Em minuta': ['C14:NEW', 'C14:PREPARATION', 'C14:UC_KHSIDR'],
  'Em assinatura': ['C14:PREPAYMENT_INVOIC', 'C14:EXECUTING'],
  'Contratada': ['CONTRATADA']
}

function formatStatus(status) {
  if (['UC_IXBSS5', "C14:UC_3AVN8G"].includes(status)) return <Badge className="badge-soft-warning mr-1">Em contratação</Badge>
  else if (["C14:NEW", "C14:PREPARATION", "C14:UC_KHSIDR"].includes(status)) return <Badge className="badge-soft-info mr-1">Em minuta</Badge>
  else if (["C14:PREPAYMENT_INVOIC", "C14:EXECUTING"].includes(status)) return <Badge className="badge-soft-success mr-1">Em assinatura</Badge>
  else if (["CONTRATADA"].includes(status)) return <Badge className="badge-soft-success mr-1">Contratada</Badge>
  else return <Badge className="badge-soft mr-1">placeholder</Badge>
}

const DEFAULT_VISAO_GERAL_PERCENTUAIS = {
  taxaAdministrativa: 15,
  taxaLucro: 40,
  taxaImpostos: 16.5,
  taxaComissao: 0.5,
  custoFinanceiro: 3,
}

function parseNumericValue(value) {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value === 'string') {
    const normalized = value.replace(/\./g, '').replace(',', '.').trim()
    if (!normalized) return null
    const parsed = Number(normalized.toFixed(2))
    return Number.isFinite(parsed) ? parsed : null
  }
  const parsed = Number(value.toFixed(2))
  return Number.isFinite(parsed) ? parsed : null
}

async function fetchAllDeals() {
  const allDeals = await powerAppsApi.post('/',
      {
        acao: 'deals_negociacoes_bitrix',
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        }
      }
    )


    return allDeals;
  // You can optionally return or process allDeals here
}

function filteredDeals(deals) {
  const todosDeals = deals.filter(d => [
    'UC_IXBSS5',
    'C14:UC_3AVN8G',
    'C14:NEW',
    'C14:PREPARATION',
    'C14:UC_KHSIDR',
    'C14:PREPAYMENT_INVOIC',
    'C14:EXECUTING',
  ].includes(d.STAGE_ID))
  const emContratacao = todosDeals.filter(d => d.STAGE_ID === 'UC_IXBSS5' || d.STAGE_ID === 'C14:UC_3AVN8G');
  const emMinuta = todosDeals.filter(d => d.STAGE_ID === 'C14:NEW' || d.STAGE_ID === 'C14:PREPARATION' || d.STAGE_ID === 'C14:UC_KHSIDR');
  const emAssinatura = todosDeals.filter(d => d.STAGE_ID === 'C14:PREPAYMENT_INVOIC' || d.STAGE_ID === 'C14:EXECUTING');
  const contratadas = deals.filter(d => d.contrato_id);

  return { allDeals: todosDeals, emMinuta, emAssinatura, emContratacao, contratadas }
}

async function fetchAllNegociacoes() {
  const allNegociacoes = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'negociacao',
    data: {
      negociacao_ativo: 1
    },
    fields: {
      '(SELECT pj_nomefanta FROM pj WHERE pj_id = negociacao.pj_id)':'pj_nomefanta',
      '(SELECT propStatus_nome FROM propStatus WHERE propStatus_id = (SELECT propStatus_id FROM prop WHERE prop_id = (SELECT prop_id FROM prop WHERE negociacao_id = negociacao.negociacao_id AND prop_ativo = 1 ORDER BY prop_dtCria DESC LIMIT 1)))':'negociacaoStatus_nome',
      '(SELECT servico_nome FROM servico WHERE servico_id = negociacao.servico_id)':'servico_nome',
      '(SELECT prop_valor FROM prop WHERE prop.negociacao_id = negociacao.negociacao_id ORDER BY prop_dtCria DESC LIMIT 1)': 'prop_valor'
    }
  })}`)
  return allNegociacoes.data;
  // You can optionally return or process allNegociacoes here
}

const columns = [
  {
    accessorKey: 'TITLE',
    header: 'Nome',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.TITLE) {
        return row.original.contrato_nome
      }
      return row.original.TITLE;
    },
    accessorFn: (row) => {
      return row.TITLE || row.contrato_nome;
    }
  },
  {
    accessorKey: 'OPPORTUNITY',
    header: 'Valor',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.OPPORTUNITY && row.original.contrato_vlrGlobal) {
        return currencyFormatter.format(row.original.contrato_vlrGlobal)
      } else if (!row.original.OPPORTUNITY) {
        return 'Sem valor';
      } else if (row.original.OPPORTUNITY) {
        return currencyFormatter.format(row.original.OPPORTUNITY);
      }
    },
    accessorFn: (row) => {
      if (!row.OPPORTUNITY) {
        return Number(row.contrato_vlrGlobal);
      }
      return Number(row.OPPORTUNITY)
    }
  },
  {
    accessorKey: 'UF_CRM_1726250379',
    header: 'Data',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.UF_CRM_1726250379 === undefined) {
        return moment(row.original.contrato_dtAssin).format('DD/MM/YYYY');
      } else if (row.original.UF_CRM_1726250379 === "") {
        return 'Sem data'
      }
      return moment(row.original.UF_CRM_1726250379).format('DD/MM/YYYY');
    },
    accessorFn: (row) => {
      if (row.UF_CRM_1726250379 === undefined) {
        return new Date(row.contrato_dtAssin);
      } else if (row.UF_CRM_1726250379 === "") {
        return 'Sem data'
      }
      return new Date(row.UF_CRM_1726250379);
    }
  },
  {
    accessorKey: 'STAGE_ID',
    header: 'Status',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.STAGE_ID) {
        return formatStatus(row.original.STAGE_ID)
      }
    },
  },
]

const columnsNegociacao = [
  /* {
    accessorKey: 'negociacao_nome',
    header: 'Nome',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.negociacao_nome) {
        return row.original.negociacao_nome
      }
      return row.original.negociacao_nome;
    },
    accessorFn: (row) => {
      return row.negociacao_nome || row.negociacao_nome;
    }
  }, */
  {
    accessorKey: 'bitrix_id',
    header: 'ID Bitrix',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.bitrix_id) {
        return 'Sem ID'
      }
      return row.original.bitrix_id;
    },
    accessorFn: (row) => {
      return row.bitrix_id || row.bitrix_id;
    }
  },
  {
    accessorKey: 'pj_nomefanta',
    header: 'Cliente',
    size: 100,
    Cell: ({ cell, row }) => {
      if (!row.original.pj_nomefanta) {
        return row.original.pj_nomefanta
      }
      return row.original.pj_nomefanta;
    },
    accessorFn: (row) => {
      return row.pj_nomefanta || row.pj_nomefanta;
    }
  },
  {
    accessorKey: 'negociacao_prazo',
    header: 'Prazo para envio',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.negociacao_prazo === undefined) {
        return moment(row.original.negociacao_prazo).format('DD/MM/YYYY');
      } else if (row.original.negociacao_prazo === "") {
        return 'Sem data'
      }
      return moment(row.original.negociacao_prazo).format('DD/MM/YYYY');
    },
    accessorFn: (row) => {
      if (row.negociacao_prazo === undefined) {
        return new Date(row.negociacao_prazo);
      } else if (row.negociacao_prazo === "") {
        return 'Sem data'
      }
      return new Date(row.negociacao_prazo);
    }
  },
  {
    accessorKey: 'negociacaoStatus_nome',
    header: 'Status',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.STAGE_ID) {
        return formatStatus(row.original.STAGE_ID)
      } else if (row.original.negociacaoStatus_nome) {
        return row.original.negociacaoStatus_nome;
      } else {
        return 'Aguardando proposta';
      }
    },
  },
  {
    accessorKey: 'servico_nome',
    header: 'Serviço',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.servico_nome) {
        return row.original.servico_nome;
      } else {
        return 'Sem serviço';
      }
    },
  },
  {
    accessorKey: 'prop_valor',
    header: 'Valor',
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.prop_valor) {
        return currencyFormatter.format(row.original.prop_valor);
      } else {
        return 'Sem valor';
      }
    },
  },
]

const columnsOrcamentoNegociacao = ({
  onReplicate,
  onContract,
  onOpenAditivaModal,
  onStartEditName,
  onChangeEditName,
  onSaveEditName,
  onCancelEditName,
  cloningOrcamentosByProp = {},
  contractingOrcamentosByProp = {},
  editingPropNames = {},
  editingDraftPropNames = {},
  savingPropNames = {},
}) => [
  {
    accessorKey: 'prop_nome',
    header: 'ID do Bitrix',
    size: 100,
    Cell: ({ row }) => {
      const propId = Number(row.original.prop_id) || 0
      const isEditing = !!editingPropNames[propId]
      const isSaving = !!savingPropNames[propId]
      const draftValue = editingDraftPropNames[propId] ?? row.original.prop_nome ?? ''

      if (isEditing) {
        return (
          <div className="d-flex align-items-center">
            <Input
              value={draftValue}
              onChange={(event) => onChangeEditName(propId, event.target.value)}
              className="mr-2"
              style={{ minWidth: 220 }}
              disabled={isSaving}
            />
            <Button
              size="sm"
              color="success"
              outline
              className="mr-1"
              disabled={isSaving}
              onClick={(event) => onSaveEditName(event, row.original)}
            >
              <CheckIcon style={{ fontSize: 18 }} />
            </Button>
            <Button
              size="sm"
              color="danger"
              outline
              disabled={isSaving}
              onClick={(event) => onCancelEditName(event, propId)}
            >
              <CloseIcon style={{ fontSize: 18 }} />
            </Button>
          </div>
        )
      }

      return (
        <div className="d-flex align-items-center">
          <span>{row.original.prop_nome || 'Sem nome'}</span>
          <Button
            size="sm"
            color="black"
            className="ml-2 p-0"
            onClick={(event) => onStartEditName(event, row.original)}
          >
            <Edit style={{ fontSize: 18 }} />
          </Button>
        </div>
      )
    }
  },
  {
    accessorKey: 'propStatus_nome',
    header: 'Status',
    size: 100,
    Cell: ({ row }) => row.original.propStatus_nome || '-'
  },
  {
    header: ' ',
    Cell: ({ row }) => (
      <>
        <a href={`https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/revisar-orcamento/${row.original.prop_id}`} target="_blank" rel="noopener noreferrer">
          <Button
            size="sm"
            color="primary"
            outline
            className="mr-2 mb-2"
          >
            {[2, 6].includes(row.original.propStatus_id) ? 'Revisar orçamento' : 'Visualizar orçamento'}
          </Button>
        </a>

        {Number(row.original.propStatus_id) !== 7 && <Button
          size="sm"
          color="primary"
          outline
          className="mr-2 mb-2"
          disabled={!!cloningOrcamentosByProp[row.original.prop_id]}
          onClick={(event) => onReplicate(event, row.original)}
        >
          {!!cloningOrcamentosByProp[row.original.prop_id] ? 'Replicando...' : 'Replicar orçamento'}
        </Button>}

        {Number(row.original.propStatus_id) === 4 &&
          <Button
            size="sm"
            color="primary"
            outline
            className="mr-2 mb-2"
            disabled={!!contractingOrcamentosByProp[row.original.prop_id]}
            onClick={(event) => onContract(event, row.original)}
          >
            {!!contractingOrcamentosByProp[row.original.prop_id] ? 'Criando contrato...' : 'Contratar'}
          </Button>
        }

        {/* {Number(row.original.propStatus_id) === 7 &&
          <Button
            size="sm"
            color="primary"
            outline
            className="mr-2 mb-2"
            onClick={(event) => onOpenAditivaModal(event, row.original)}
          >
            Montar proposta aditiva
          </Button>
        } */}

        {/* <a href={`https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/revisar-escopo-orcamento/${row.original.prop_id}`} target="_blank" rel="noopener noreferrer">
          <Button
            size="sm"
            color="primary"
            outline
            className="mr-2 mb-2"
          >
            Revisar escopo e orçamento
          </Button>
        </a> */}
      </>
    )
  },
]

const columnsAditivosNegociacao = [
  {
    accessorKey: 'negociacao_nome',
    header: 'Nome',
    size: 220,
    Cell: ({ row }) => row.original.negociacao_nome || 'Sem nome',
  },
  {
    accessorKey: 'pj_nomefanta',
    header: 'Cliente',
    size: 180,
    Cell: ({ row }) => row.original.pj_nomefanta || 'Sem cliente',
  },
  {
    accessorKey: 'negociacao_prazo',
    header: 'Prazo para envio',
    size: 140,
    Cell: ({ row }) => row.original.negociacao_prazo ? moment(row.original.negociacao_prazo).format('DD/MM/YYYY') : 'Sem data',
    accessorFn: (row) => row.negociacao_prazo ? new Date(row.negociacao_prazo) : null,
  },
  {
    accessorKey: 'negociacaoStatus_nome',
    header: 'Status',
    size: 140,
    Cell: ({ row }) => row.original.negociacaoStatus_nome || 'Aguardando proposta',
  },
  {
    accessorKey: 'servico_nome',
    header: 'Serviço',
    size: 180,
    Cell: ({ row }) => row.original.servico_nome || 'Sem serviço',
  },
  {
    accessorKey: 'prop_valor',
    header: 'Valor',
    size: 140,
    Cell: ({ row }) => row.original.prop_valor ? currencyFormatter.format(row.original.prop_valor) : 'Sem valor',
    accessorFn: (row) => Number(row.prop_valor || 0),
  },
  {
    accessorKey: 'negociacao_id',
    header: 'ID',
    size: 80,
    Cell: ({ row }) => row.original.negociacao_id || '-',
  },
]

class Acompanhamento extends Component {
  constructor(props) {
    super(props)
    this.state = {
      statusFilter: {value: 'Todas', label: 'Todas'},
      dateFilter: null,
      addContractModalIsOpen: false,
      addContractDataDraft: {},

      addDraftContractModalIsOpen: false,
      addDraftContractPreviousData: {},
      addNegociacaoModalIsOpen: false,
      isSavingNegociacao: false,
      novaNegociacaoData: {
        negociacao_prazo: null,
        bitrix_id: '',
        negociacao_obj: '',
        pj_id: null,
        areaAtua_id: null,
        negociacao_codTrib: '',
        servico_id: null,
      },
      pjOptions: [],
      areaAtuaOptions: [],
      servicoOptions: [],
      allDeals: null,
      allNegociacoes: null,
      selectedServicoByNegociacao: {},
      filteredDeals: null,
      orcamentosByNegociacao: {},
      aditivosByNegociacao: {},
      loadingOrcamentosByNegociacao: {},
      loadingAditivosByNegociacao: {},
      savingServicoByNegociacao: {},
      savingOrcamentosByNegociacao: {},
      editingPropNames: {},
      editingDraftPropNames: {},
      savingPropNames: {},
      selectedModeloByNegociacao: {},
      modeloOptionsByNegociacao: {},
      loadingModelosByNegociacao: {},
      creatingModeloByNegociacao: {},
      showModeloSelectByNegociacao: {},
      additivaModalIsOpen: false,
      additivaModalSourceProp: null,
      additivaModalShowModeloSelect: false,
      cloningOrcamentosByProp: {},
      contractingOrcamentosByProp: {},
      expandedNegociacoes: {},
      activeExpandedTabByNegociacao: {},
    }
  }

  buildSelectedServicosMap = (negociacoes = []) => (
    Array.isArray(negociacoes)
      ? negociacoes.reduce((acc, negociacao) => {
          const negociacaoId = Number(negociacao?.negociacao_id) || 0
          if (negociacaoId) {
            acc[negociacaoId] = negociacao?.servico_id ?? null
          }
          return acc
        }, {})
      : {}
  )

  getInitialNovaNegociacaoData = () => ({
    negociacao_prazo: null,
    bitrix_id: '',
    negociacao_obj: '',
    pj_id: null,
    areaAtua_id: null,
    negociacao_codTrib: '',
    servico_id: null,
  })

  fetchNegociacaoFormOptions = async () => {
    const [pjRes, areaAtuaRes, servicoRes] = await Promise.all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: {
          pj_ativo: 1,
        },
        fields: {
          pj_id: 'value',
          pj_razaosocial: 'pj_razaosocial',
          pj_nomefanta: 'pj_nomefanta',
        }
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'areaAtua',
        fields: {
          areaAtua_id: 'value',
          areaAtua_area: 'label',
        }
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'servico',
        data: {
          servico_ativo: 1,
        },
        fields: {
          servico_id: 'value',
          servico_nome: 'label',
        }
      })}`),
    ])

    const pjOptions = (Array.isArray(pjRes?.data) ? pjRes.data : []).map((pj) => ({
      value: pj.value ?? pj.pj_id,
      label: String(pj.pj_razaosocial || pj.pj_nomefanta || '').trim() || 'Sem nome',
    }))

    this.setState({
      pjOptions,
      areaAtuaOptions: Array.isArray(areaAtuaRes?.data) ? areaAtuaRes.data : [],
      servicoOptions: Array.isArray(servicoRes?.data) ? servicoRes.data : [],
    })
  }

  openAddNegociacaoModal = () => {
    this.setState({
      addNegociacaoModalIsOpen: true,
      novaNegociacaoData: this.getInitialNovaNegociacaoData(),
    })
  }

  closeAddNegociacaoModal = () => {
    this.setState({
      addNegociacaoModalIsOpen: false,
      isSavingNegociacao: false,
      novaNegociacaoData: this.getInitialNovaNegociacaoData(),
    })
  }

  handleNovaNegociacaoChange = (field, value) => {
    this.setState((prevState) => ({
      novaNegociacaoData: {
        ...prevState.novaNegociacaoData,
        [field]: value,
      }
    }))
  }

  saveNegociacao = async () => {
    const {
      negociacao_prazo,
      bitrix_id,
      negociacao_obj,
      pj_id,
      //areaAtua_id,
      negociacao_codTrib,
      servico_id,
      negociacao_nome
    } = this.state.novaNegociacaoData

    //|| !areaAtua_id
    if (!negociacao_prazo || !bitrix_id || !negociacao_obj || !pj_id || !negociacao_codTrib || !servico_id) {
      notifyError('Preencha todos os campos da nova negociação.')
      return
    }

    this.setState({ isSavingNegociacao: true })

    try {
      await oikosApi.post('/', {
        action: 'insert',
        table: 'negociacao',
        data: {
          negociacao_prazo: moment(negociacao_prazo).format('YYYY-MM-DD'),
          bitrix_id: parseNumericValue(Number(bitrix_id)) ?? bitrix_id,
          negociacao_obj,
          pj_id,
          //areaAtua_id,
          negociacao_codTrib,
          servico_id,
          negociacao_usuarioCria: this.props?.auth?.user?.pf_id,
          negociacao_usuarioMod: this.props?.auth?.user?.pf_id,
          negociacao_nome
        },
      })

      const allNegociacoes = await fetchAllNegociacoes()
      this.setState({
        allNegociacoes,
        selectedServicoByNegociacao: this.buildSelectedServicosMap(allNegociacoes),
        addNegociacaoModalIsOpen: false,
        isSavingNegociacao: false,
        novaNegociacaoData: this.getInitialNovaNegociacaoData(),
      })
      notifySuccess('Negociação criada com sucesso.')
    } catch (error) {
      console.error('Erro ao criar negociação', error)
      this.setState({ isSavingNegociacao: false })
      notifyError('Não foi possível criar a negociação.')
    }
  }

  handleOrcamentoAction = (event, action, rowOriginal) => {
    if (event?.stopPropagation) event.stopPropagation();
    if (event?.preventDefault) event.preventDefault();

    void action;
    void rowOriginal;
  }

  handleStartEditPropNome = (event, rowOriginal) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const propId = Number(rowOriginal?.prop_id) || 0
    if (!propId) return

    this.setState((prevState) => ({
      editingPropNames: {
        ...prevState.editingPropNames,
        [propId]: true,
      },
      editingDraftPropNames: {
        ...prevState.editingDraftPropNames,
        [propId]: rowOriginal?.prop_nome || '',
      }
    }))
  }

  handleChangeEditPropNome = (propId, value) => {
    if (!propId) return

    this.setState((prevState) => ({
      editingDraftPropNames: {
        ...prevState.editingDraftPropNames,
        [propId]: value,
      }
    }))
  }

  handleCancelEditPropNome = (event, propId) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()
    if (!propId) return

    this.setState((prevState) => ({
      editingPropNames: {
        ...prevState.editingPropNames,
        [propId]: false,
      },
      editingDraftPropNames: {
        ...prevState.editingDraftPropNames,
        [propId]: undefined,
      }
    }))
  }

  handleSaveEditPropNome = async (event, rowOriginal) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const propId = Number(rowOriginal?.prop_id) || 0
    const negociacaoId = Number(rowOriginal?.negociacao_id) || 0
    const draftValue = String(this.state.editingDraftPropNames[propId] ?? '').trim()
    const userId = Number(this.props?.auth?.user?.pf_id) || 0

    if (!propId || !negociacaoId) {
      notifyError('NÃ£o foi possÃ­vel identificar a proposta.')
      return
    }

    if (!draftValue) {
      notifyError('Informe um nome para a proposta.')
      return
    }

    this.setState((prevState) => ({
      savingPropNames: {
        ...prevState.savingPropNames,
        [propId]: true,
      }
    }))

    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'prop',
        data: {
          prop_id: propId,
          prop_nome: draftValue,
          prop_usuarioMod: userId,
        },
      })

      this.setState((prevState) => ({
        orcamentosByNegociacao: {
          ...prevState.orcamentosByNegociacao,
          [negociacaoId]: Array.isArray(prevState.orcamentosByNegociacao[negociacaoId])
            ? prevState.orcamentosByNegociacao[negociacaoId].map((propRow) => (
                Number(propRow?.prop_id) === propId
                  ? { ...propRow, prop_nome: draftValue }
                  : propRow
              ))
            : prevState.orcamentosByNegociacao[negociacaoId],
        },
        editingPropNames: {
          ...prevState.editingPropNames,
          [propId]: false,
        },
        editingDraftPropNames: {
          ...prevState.editingDraftPropNames,
          [propId]: undefined,
        }
      }))

      notifySuccess('Nome da proposta atualizado com sucesso.')
    } catch (error) {
      console.error('Erro ao atualizar nome da proposta', error)
      notifyError('NÃ£o foi possÃ­vel atualizar o nome da proposta.')
    } finally {
      this.setState((prevState) => ({
        savingPropNames: {
          ...prevState.savingPropNames,
          [propId]: false,
        }
      }))
    }
  }

  handleNegociacaoServicoChange = (negociacaoId, option) => {
    if (!negociacaoId) return

    this.setState((prevState) => ({
      selectedServicoByNegociacao: {
        ...prevState.selectedServicoByNegociacao,
        [negociacaoId]: option?.value ?? null,
      }
    }))
  }

  handleNegociacaoModeloChange = (negociacaoId, option) => {
    if (!negociacaoId) return

    this.setState((prevState) => ({
      selectedModeloByNegociacao: {
        ...prevState.selectedModeloByNegociacao,
        [negociacaoId]: option || null,
      }
    }))
  }

  loadModeloOptionsForNegociacao = async (negociacaoId, servicoId) => {
    const modeloOptions = await this.getModelosPropostaByServico(servicoId)

    this.setState((prevState) => ({
      modeloOptionsByNegociacao: {
        ...prevState.modeloOptionsByNegociacao,
        [negociacaoId]: Array.isArray(modeloOptions) ? modeloOptions : [],
      }
    }))
  }

  toggleNegociacaoModeloSelect = async (rowOriginal) => {
    const negociacaoId = Number(rowOriginal?.negociacao_id) || 0
    if (!negociacaoId) return

    const isOpen = !!this.state.showModeloSelectByNegociacao[negociacaoId]
    if (isOpen) {
      this.setState((prevState) => ({
        showModeloSelectByNegociacao: {
          ...prevState.showModeloSelectByNegociacao,
          [negociacaoId]: false,
        }
      }))
      return
    }

    const servicoId = this.state.selectedServicoByNegociacao[negociacaoId] ?? rowOriginal?.servico_id ?? null
    if (!servicoId) {
      notifyError('Selecione e salve um serviÃ§o antes de carregar os modelos.')
      return
    }

    this.setState((prevState) => ({
      loadingModelosByNegociacao: {
        ...prevState.loadingModelosByNegociacao,
        [negociacaoId]: true,
      }
    }))

    try {
      await this.loadModeloOptionsForNegociacao(negociacaoId, servicoId)
      this.setState((prevState) => ({
        showModeloSelectByNegociacao: {
          ...prevState.showModeloSelectByNegociacao,
          [negociacaoId]: true,
        }
      }))
    } catch (error) {
      console.error('Erro ao carregar modelos de proposta', error)
      notifyError('NÃ£o foi possÃ­vel carregar os modelos de proposta.')
    } finally {
      this.setState((prevState) => ({
        loadingModelosByNegociacao: {
          ...prevState.loadingModelosByNegociacao,
          [negociacaoId]: false,
        }
      }))
    }
  }

  openAditivaModal = (event, sourceProp) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const negociacaoId = Number(sourceProp?.negociacao_id) || 0

    this.setState((prevState) => ({
      additivaModalIsOpen: true,
      additivaModalSourceProp: sourceProp || null,
      additivaModalShowModeloSelect: false,
      selectedModeloByNegociacao: negociacaoId
        ? {
            ...prevState.selectedModeloByNegociacao,
            [negociacaoId]: null,
          }
        : prevState.selectedModeloByNegociacao,
    }))
  }

  closeAditivaModal = () => {
    const negociacaoId = Number(this.state.additivaModalSourceProp?.negociacao_id) || 0

    this.setState((prevState) => ({
      additivaModalIsOpen: false,
      additivaModalSourceProp: null,
      additivaModalShowModeloSelect: false,
      selectedModeloByNegociacao: negociacaoId
        ? {
            ...prevState.selectedModeloByNegociacao,
            [negociacaoId]: null,
          }
        : prevState.selectedModeloByNegociacao,
    }))
  }

  handleOpenAditivaModeloFlow = async () => {
    const sourceProp = this.state.additivaModalSourceProp
    const negociacaoId = Number(sourceProp?.negociacao_id) || 0
    if (!negociacaoId) return

    const servicoId = this.state.selectedServicoByNegociacao[negociacaoId] ?? sourceProp?.servico_id ?? null
    if (!servicoId) {
      notifyError('Selecione e salve um serviço antes de carregar os modelos.')
      return
    }

    this.setState((prevState) => ({
      loadingModelosByNegociacao: {
        ...prevState.loadingModelosByNegociacao,
        [negociacaoId]: true,
      }
    }))

    try {
      await this.loadModeloOptionsForNegociacao(negociacaoId, servicoId)
      this.setState({
        additivaModalShowModeloSelect: true,
      })
    } catch (error) {
      console.error('Erro ao carregar modelos de proposta para aditivo', error)
      notifyError('Não foi possível carregar os modelos de proposta.')
    } finally {
      this.setState((prevState) => ({
        loadingModelosByNegociacao: {
          ...prevState.loadingModelosByNegociacao,
          [negociacaoId]: false,
        }
      }))
    }
  }

  handleCriarPropostaAditivaPorModelo = async () => {
    const sourceProp = this.state.additivaModalSourceProp
    const negociacaoId = Number(sourceProp?.negociacao_id) || 0
    const userId = Number(this.props?.auth?.user?.pf_id) || 0
    const selectedModelo = this.state.selectedModeloByNegociacao[negociacaoId] || null
    const sourcePropId = Number(selectedModelo?.prop_id) || 0

    if (!negociacaoId || !sourcePropId) {
      notifyError('Selecione um modelo de proposta antes de criar.')
      return
    }

    this.setState((prevState) => ({
      creatingModeloByNegociacao: {
        ...prevState.creatingModeloByNegociacao,
        [negociacaoId]: true,
      }
    }))

    try {
      await this.clonePropToNegociacao(sourcePropId, negociacaoId, userId)
      notifySuccess('Proposta criada a partir do modelo com sucesso.')
      this.closeAditivaModal()
    } catch (error) {
      console.error('Erro ao criar proposta aditiva a partir do modelo', error)
      notifyError('Não foi possível criar a proposta a partir do modelo.')
    } finally {
      this.setState((prevState) => ({
        creatingModeloByNegociacao: {
          ...prevState.creatingModeloByNegociacao,
          [negociacaoId]: false,
        }
      }))
    }
  }

  handleCriarPropostaAditivaEmBranco = async () => {
    const sourceProp = this.state.additivaModalSourceProp
    const negociacaoId = Number(sourceProp?.negociacao_id) || 0
    const propId = Number(sourceProp?.prop_id) || 0
    const userId = Number(this.props?.auth?.user?.pf_id) || 0
    if (!negociacaoId || !propId) return

    this.setState((prevState) => ({
      savingOrcamentosByNegociacao: {
        ...prevState.savingOrcamentosByNegociacao,
        [negociacaoId]: true,
      }
    }))

    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'prop',
        data: {
          prop_id: propId,
          propStatus_id: 2,
          ...(userId ? { prop_usuarioMod: userId } : {}),
        },
      })

      await this.loadOrcamentosByNegociacao(negociacaoId)

      window.open(
        `https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/revisar-orcamento/${propId}`,
        '_blank',
        'noopener,noreferrer'
      )

      this.closeAditivaModal()
    } catch (error) {
      console.error('Erro ao preparar proposta aditiva em branco', error)
      notifyError('Não foi possível colocar a proposta em elaboração.')
    } finally {
      this.setState((prevState) => ({
        savingOrcamentosByNegociacao: {
          ...prevState.savingOrcamentosByNegociacao,
          [negociacaoId]: false,
        }
      }))
    }
  }

  handleCriarPropostaAditivaOriginal = async () => {
    const sourceProp = this.state.additivaModalSourceProp
    if (!sourceProp) return

    await this.replicateOrcamento(null, sourceProp)
    this.closeAditivaModal()
  }

  handleCriarPropostaPorModelo = async (event, rowOriginal) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const negociacaoId = Number(rowOriginal?.negociacao_id) || 0
    const bitrixId = Number(rowOriginal?.bitrix_id) || 0
    const userId = Number(this.props?.auth?.user?.pf_id) || 0
    const selectedModelo = this.state.selectedModeloByNegociacao[negociacaoId] || null
    const sourcePropId = Number(selectedModelo?.prop_id) || 0

    if (!negociacaoId || !sourcePropId) {
      notifyError('Selecione um modelo de proposta antes de criar.')
      return
    }

    this.setState((prevState) => ({
      creatingModeloByNegociacao: {
        ...prevState.creatingModeloByNegociacao,
        [negociacaoId]: true,
      }
    }))

    try {
      await this.clonePropToNegociacao(sourcePropId, negociacaoId, userId, bitrixId)
      notifySuccess('Proposta criada a partir do modelo com sucesso.')
    } catch (error) {
      console.error('Erro ao criar proposta a partir do modelo', error)
      notifyError('Não foi possível criar a proposta a partir do modelo.')
    } finally {
      this.setState((prevState) => ({
        creatingModeloByNegociacao: {
          ...prevState.creatingModeloByNegociacao,
          [negociacaoId]: false,
        }
      }))
    }
  }

  saveNegociacaoServico = async (event, rowOriginal) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const negociacaoId = Number(rowOriginal?.negociacao_id) || 0
    if (!negociacaoId) {
      notifyError('Não foi possível identificar a negociação.')
      return
    }

    const servicoId = this.state.selectedServicoByNegociacao[negociacaoId] ?? null
    if (!servicoId) {
      notifyError('Selecione um serviço antes de salvar.')
      return
    }

    const userId = Number(this.props?.auth?.user?.pf_id) || 0

    this.setState((prevState) => ({
      savingServicoByNegociacao: {
        ...prevState.savingServicoByNegociacao,
        [negociacaoId]: true,
      }
    }))

    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'negociacao',
        data: {
          negociacao_id: negociacaoId,
          servico_id: servicoId,
          negociacao_usuarioMod: userId,
        },
      })

      const selectedServico = this.state.servicoOptions.find((option) => option.value === servicoId)

      this.setState((prevState) => ({
        allNegociacoes: Array.isArray(prevState.allNegociacoes)
          ? prevState.allNegociacoes.map((negociacao) => (
              Number(negociacao?.negociacao_id) === negociacaoId
                ? {
                    ...negociacao,
                    servico_id: servicoId,
                    servico_nome: selectedServico?.label || negociacao?.servico_nome || null,
                  }
                : negociacao
            ))
          : prevState.allNegociacoes,
      }))

      notifySuccess('Serviço da negociação atualizado com sucesso.')
    } catch (error) {
      console.error('Erro ao atualizar serviço da negociação', error)
      notifyError('Não foi possível atualizar o serviço da negociação.')
    } finally {
      this.setState((prevState) => ({
        savingServicoByNegociacao: {
          ...prevState.savingServicoByNegociacao,
          [negociacaoId]: false,
        }
      }))
    }
  }

  fetchOrcamentosByNegociacao = async (negociacao_id) => {
    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prop',
      data: {
        negociacao_id,
        prop_ativo: 1
      },
      fields: {
        propStatus_id: 'propStatus_id',
        '(SELECT propStatus_nome FROM propStatus WHERE propStatus_id = prop.propStatus_id)': 'propStatus_nome'
      }
    })}`)

    const rows = Array.isArray(response.data) ? response.data : []
    return rows.sort((a, b) => Number(b.prop_id || 0) - Number(a.prop_id || 0))
  }

  loadOrcamentosByNegociacao = async (negociacao_id) => {
    if (!negociacao_id) return;

    this.setState((prevState) => ({
      loadingOrcamentosByNegociacao: {
        ...prevState.loadingOrcamentosByNegociacao,
        [negociacao_id]: true
      }
    }))

    try {
      const rows = await this.fetchOrcamentosByNegociacao(negociacao_id);
      this.setState((prevState) => ({
        orcamentosByNegociacao: {
          ...prevState.orcamentosByNegociacao,
          [negociacao_id]: rows
        }
      }))
    } finally {
      this.setState((prevState) => ({
        loadingOrcamentosByNegociacao: {
          ...prevState.loadingOrcamentosByNegociacao,
          [negociacao_id]: false
        }
      }))
    }
  }

  fetchAditivosByNegociacao = async (negociacao_id) => {
    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'negociacao',
      data: {
        negociacao_original: negociacao_id,
        negociacao_ativo: 1,
      },
      fields: {
        '(SELECT pj_nomefanta FROM pj WHERE pj_id = negociacao.pj_id)': 'pj_nomefanta',
        '(SELECT propStatus_nome FROM propStatus WHERE propStatus_id = (SELECT propStatus_id FROM prop WHERE prop_id = (SELECT prop_id FROM prop WHERE negociacao_id = negociacao.negociacao_id AND prop_ativo = 1 ORDER BY prop_dtCria DESC LIMIT 1)))': 'negociacaoStatus_nome',
        '(SELECT servico_nome FROM servico WHERE servico_id = negociacao.servico_id)': 'servico_nome',
        '(SELECT prop_valor FROM prop WHERE prop.negociacao_id = negociacao.negociacao_id ORDER BY prop_dtCria DESC LIMIT 1)': 'prop_valor'
      }
    })}`)

    const rows = Array.isArray(response.data) ? response.data : []
    return rows.sort((a, b) => Number(b.negociacao_id || 0) - Number(a.negociacao_id || 0))
  }

  loadAditivosByNegociacao = async (negociacao_id) => {
    if (!negociacao_id) return;

    this.setState((prevState) => ({
      loadingAditivosByNegociacao: {
        ...prevState.loadingAditivosByNegociacao,
        [negociacao_id]: true
      }
    }))

    try {
      const rows = await this.fetchAditivosByNegociacao(negociacao_id)
      this.setState((prevState) => ({
        aditivosByNegociacao: {
          ...prevState.aditivosByNegociacao,
          [negociacao_id]: rows
        }
      }))
    } finally {
      this.setState((prevState) => ({
        loadingAditivosByNegociacao: {
          ...prevState.loadingAditivosByNegociacao,
          [negociacao_id]: false
        }
      }))
    }
  }

  ensureOrcamentosLoaded = (negociacao_id) => {
    if (!negociacao_id) return;

    const hasRows = Array.isArray(this.state.orcamentosByNegociacao[negociacao_id]);
    const isLoading = !!this.state.loadingOrcamentosByNegociacao[negociacao_id];

    if (!hasRows && !isLoading) {
      this.loadOrcamentosByNegociacao(negociacao_id);
    }
  }

  ensureAditivosLoaded = (negociacao_id) => {
    if (!negociacao_id) return;

    const hasRows = Array.isArray(this.state.aditivosByNegociacao[negociacao_id]);
    const isLoading = !!this.state.loadingAditivosByNegociacao[negociacao_id];

    if (!hasRows && !isLoading) {
      this.loadAditivosByNegociacao(negociacao_id);
    }
  }

  handleExpandedNegociacoesChange = (updater) => {
    const nextExpanded = typeof updater === 'function'
      ? updater(this.state.expandedNegociacoes)
      : updater

    this.setState({ expandedNegociacoes: nextExpanded })

    Object.keys(nextExpanded || {}).forEach((negociacaoId) => {
      if (nextExpanded[negociacaoId]) {
        const numericNegociacaoId = Number(negociacaoId)
        this.ensureOrcamentosLoaded(numericNegociacaoId)
        this.ensureAditivosLoaded(numericNegociacaoId)
      }
    })
  }

  handleExpandedNegociacaoTabChange = (negociacaoId, tabKey) => {
    if (!negociacaoId) return

    this.setState((prevState) => ({
      activeExpandedTabByNegociacao: {
        ...prevState.activeExpandedTabByNegociacao,
        [negociacaoId]: tabKey,
      }
    }))

    if (tabKey === 'aditivos') {
      this.ensureAditivosLoaded(negociacaoId)
      return
    }

    this.ensureOrcamentosLoaded(negociacaoId)
  }

  saveOrcamento = async (event, negociacao_id, rowObject) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()
    if (!negociacao_id) return

    this.setState((prevState) => ({
      savingOrcamentosByNegociacao: {
        ...prevState.savingOrcamentosByNegociacao,
        [negociacao_id]: true
      }
    }))

    try {
      const propCreated = await oikosApi.post(
        '/',
        {
          action: 'insert',
          table: 'prop',
          data: {
            negociacao_id,
            bitrix_id: rowObject.bitrix_id,
            prop_nome: `${rowObject.servico_nome} | ${rowObject.bitrix_id} v1`
          }
        }
      )
      const newPropId = Number(
        propCreated?.data?.[0]?.prop_id ??
        propCreated?.data?.prop_id
      ) || 0

      if (newPropId) {
        window.open(
          `https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/revisar-orcamento/${newPropId}`,
          '_blank',
          'noopener,noreferrer'
        )
      }
      await this.loadOrcamentosByNegociacao(negociacao_id)
    } finally {
      this.setState((prevState) => ({
        savingOrcamentosByNegociacao: {
          ...prevState.savingOrcamentosByNegociacao,
          [negociacao_id]: false
        }
      }))
    }
  }

  getNextPropVersionForNegociacao = (negociacaoId) => {
    const orcamentos = this.state.orcamentosByNegociacao[negociacaoId] || []
    let maxVersion = 0

    for (const prop of orcamentos) {
      const match = String(prop?.prop_nome || '').match(/\sv(\d+)$/i)
      if (match) {
        maxVersion = Math.max(maxVersion, Number(match[1]) || 0)
      }
    }

    return Math.max(maxVersion, orcamentos.length) + 1
  }

  clonePropData = (propData, negociacaoId, bitrixId, userId, nextVersion, modelo=false) => {
    const version = Number(nextVersion) > 0 ? Number(nextVersion) : 1
    let sourcePropNome = String(propData?.prop_nome || '').trim()
    if (modelo) {
      sourcePropNome = `${propData.servico_nome} | ${bitrixId}`
    }
    const basePropNome = sourcePropNome.replace(/\s+v\d+$/i, '').trim()
    const nextPropNome = basePropNome
      ? `${basePropNome} v${version}`
      : `Proposta clonada v${version}`

    return {
      negociacao_id: negociacaoId,
      bitrix_id: modelo ? bitrixId : propData?.bitrix_id,
      prop_nome: nextPropNome,
      prop_prazoExec: propData?.prop_prazoExec ?? undefined,
      propStatus_id: 2,
      prop_aliqImposto: propData?.prop_aliqImposto ?? undefined,
      prop_aliqAdmin: propData?.prop_aliqAdmin ?? undefined,
      prop_aliqLucro: propData?.prop_aliqLucro ?? undefined,
      prop_aliqCLT: propData?.prop_aliqCLT ?? undefined,
      prop_aliqCustoFin: propData?.prop_aliqCustoFin ?? undefined,
      prop_aliqRemFin: propData?.prop_aliqRemFin ?? undefined,
      ...(userId ? {
        prop_usuarioCria: userId,
        prop_usuarioMod: userId,
      } : {}),
    }
  }

  clonePropToNegociacao = async (sourcePropId, negociacaoId, userId, bitrixId) => {
    const [propRes, childData] = await Promise.all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prop',
        data: {
          prop_id: sourcePropId,
          prop_ativo: 1,
        },
        fields: {
          "(SELECT servico_nome FROM servico WHERE servico_id = (SELECT servico_id FROM negociacao WHERE negociacao_id = prop.negociacao_id))" : "servico_nome"
        }
      })}`),
      this.fetchPropChildren(sourcePropId),
    ])

    const sourcePropData = Array.isArray(propRes?.data) ? propRes.data[0] : null
    if (!sourcePropData) {
      throw new Error('Proposta de origem nÃ£o encontrada.')
    }

    const newPropRes = await oikosApi.post('/', {
      action: 'insert',
      table: 'prop',
      data: this.clonePropData(sourcePropData, negociacaoId, bitrixId, userId, this.getNextPropVersionForNegociacao(negociacaoId), true),
    })

    const newPropId = Number(newPropRes?.data?.[0]?.prop_id) || 0
    if (!newPropId) {
      throw new Error('Não foi possível criar a proposta clonada.')
    }

    const prodPropIdMap = new Map()
    const eventoPagamentoPropIdMap = new Map()

    for (const propItem of childData.propItens) {
      const sourcePropOrcItemId = Number(propItem?.propOrcItem_id) || 0
      const propItemId = Number(propItem?.propItem_id) || 0
      if (!sourcePropOrcItemId || !propItemId) continue

      const propOrcItemRes = await oikosApi.post('/', {
        action: 'insert',
        table: 'propOrcItem',
        data: {
          prop_id: newPropId,
          propOrcItem_desc: propItem?.propOrcItem_desc,
          propItem_id: propItemId,
          propOrcItem_valor: propItem?.propOrcItem_valor,
          propOrcItem_qtd: propItem?.propOrcItem_qtd,
          propEstrut_id: propItem?.propEstrut_id ?? undefined,
          ...(userId ? {
            propOrcItem_usuarioCria: userId,
            propOrcItem_usuarioMod: userId,
          } : {}),
        },
      })

      const newPropOrcItemId = Number(propOrcItemRes?.data?.[0]?.propOrcItem_id) || 0
      if (!newPropOrcItemId) continue

      const propOrcs = childData.propOrcsByItem.get(sourcePropOrcItemId) || []
      for (const propOrc of propOrcs) {
        await oikosApi.post('/', {
          action: 'insert',
          table: 'propOrc',
          data: {
            propOrcItem_id: newPropOrcItemId,
            propOrc_mes: propOrc?.propOrc_mes,
            propOrc_qtde: propOrc?.propOrc_qtde,
            ...(userId ? {
              propOrc_usuarioCria: userId,
              propOrc_usuarioMod: userId,
            } : {}),
          },
        })
      }
    }

    for (const eventoPagamentoProp of childData.eventosPagamentoProp) {
      const sourceEventoId = Number(eventoPagamentoProp?.eventoPagamentoProp_id) || 0
      if (!sourceEventoId) continue

      const eventoPagamentoPropRes = await oikosApi.post('/', {
        action: 'insert',
        table: 'eventoPagamentoProp',
        data: {
          prop_id: newPropId,
          eventoPagamentoProp_nome: eventoPagamentoProp?.eventoPagamentoProp_nome,
          eventoPagamentoProp_prazoPgto: eventoPagamentoProp?.eventoPagamentoProp_prazoPgto,
          eventoPagamentoProp_vlr: eventoPagamentoProp?.eventoPagamentoProp_vlr,
          recTp_id: eventoPagamentoProp?.recTp_id ?? null,
          ...(userId ? {
            eventoPagamentoProp_usuarioCria: userId,
            eventoPagamentoProp_usuarioMod: userId,
          } : {}),
        },
      })

      const newEventoId = Number(eventoPagamentoPropRes?.data?.[0]?.eventoPagamentoProp_id) || 0
      if (newEventoId) {
        eventoPagamentoPropIdMap.set(sourceEventoId, newEventoId)
      }
    }

    for (const prodProp of childData.prodsProp) {
      const sourceProdId = Number(prodProp?.prodProp_id) || 0
      if (!sourceProdId) continue

      const prodPropRes = await oikosApi.post('/', {
        action: 'insert',
        table: 'prodProp',
        data: {
          prop_id: newPropId,
          prodProp_nome: prodProp?.prodProp_nome,
          prodProp_prazoEntrega: prodProp?.prodProp_prazoEntrega,
          ...(userId ? {
            prodProp_usuarioCria: userId,
            prodProp_usuarioMod: userId,
          } : {}),
        },
      })

      const newProdId = Number(prodPropRes?.data?.[0]?.prodProp_id) || 0
      if (newProdId) {
        prodPropIdMap.set(sourceProdId, newProdId)
      }
    }

    for (const relacao of childData.relacoes) {
      const sourceProdId = Number(relacao?.prodProp_id) || 0
      const sourceEventoId = Number(relacao?.eventoPagamentoProp_id) || 0
      const newProdId = prodPropIdMap.get(sourceProdId) || 0
      const newEventoId = eventoPagamentoPropIdMap.get(sourceEventoId) || 0

      if (!newProdId || !newEventoId) continue

      await oikosApi.post('/', {
        action: 'insert',
        table: 'relacaoPropEPPropProdProp',
        data: {
          prop_id: newPropId,
          prodProp_id: newProdId,
          eventoPagamentoProp_id: newEventoId,
          ...(userId ? {
            relacaoPropEPPropProdProp_usuarioCria: userId,
            relacaoPropEPPropProdProp_usuarioMod: userId,
          } : {}),
        },
      })
    }

    await this.loadOrcamentosByNegociacao(negociacaoId)

    return newPropId
  }

  fetchPropChildren = async (propId) => {
    const [propItensRes, prodsPropRes, eventosPagamentoPropRes, relacoesRes] = await Promise.all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'propOrcItem',
        data: {
          prop_id: propId,
          propOrcItem_ativo: 1,
        },
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prodProp',
        data: {
          prop_id: propId,
          prodProp_ativo: 1,
        },
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'eventoPagamentoProp',
        data: {
          prop_id: propId,
          eventoPagamentoProp_ativo: 1,
        },
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'relacaoPropEPPropProdProp',
        data: {
          prop_id: propId,
          relacaoPropEPPropProdProp_ativo: 1,
        },
      })}`),
    ])

    const propItens = Array.isArray(propItensRes?.data) ? propItensRes.data : []
    const prodsProp = Array.isArray(prodsPropRes?.data) ? prodsPropRes.data : []
    const eventosPagamentoProp = Array.isArray(eventosPagamentoPropRes?.data) ? eventosPagamentoPropRes.data : []
    const relacoes = Array.isArray(relacoesRes?.data) ? relacoesRes.data : []

    const propOrcResponses = await Promise.all(
      propItens.map(async (propItem) => {
        const propOrcItemId = Number(propItem?.propOrcItem_id) || 0
        if (!propOrcItemId) return []

        const response = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'propOrc',
          data: {
            propOrcItem_id: propOrcItemId,
          },
        })}`)

        return Array.isArray(response?.data) ? response.data : []
      })
    )

    return {
      propItens,
      propOrcsByItem: new Map(
        propItens.map((propItem, index) => [Number(propItem?.propOrcItem_id) || 0, propOrcResponses[index] || []])
      ),
      prodsProp,
      eventosPagamentoProp,
      relacoes,
    }
  }

  fetchPropResumo = async (propId) => {
    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prop',
      data: {
        prop_id: propId,
        prop_ativo: 1,
      },
      fields: {
        prop_id: 'prop_id',
        prop_nome: 'prop_nome',
        prop_dtCria: 'prop_dtCria',
        bitrix_id: 'bitrix_id',
        prop_valor: 'prop_valor',
        prop_vlrBaseCustos: 'prop_vlrBaseCustos',
        prop_vlrImposto: 'prop_vlrImposto',
        prop_vlrAdmin: 'prop_vlrAdmin',
        prop_vlrCustoFin: 'prop_vlrCustoFin',
        prop_vlrLucro: 'prop_vlrLucro',
        '(SELECT pj_id FROM negociacao WHERE negociacao_id = prop.negociacao_id)': 'pj_id',
      }
    })}`)

    return Array.isArray(response?.data) ? response.data[0] : null
  }

  buildContratoResumo = (childData) => {
    const propItens = childData?.propItens || []
    const percentuais = DEFAULT_VISAO_GERAL_PERCENTUAIS

    const visaoGeralTotal = propItens.reduce((acc, propItem) => {
      const qtd = parseNumericValue(Number(propItem?.propOrcItem_qtd)) || 0
      const valor = parseNumericValue(Number(propItem?.propOrcItem_valor)) || 0
      return acc + (qtd * valor)
    }, 0)

    const visaoGeralCustoAdministrativo = visaoGeralTotal * ((parseNumericValue(Number(percentuais?.taxaAdministrativa)) || 0) / 100)
    const visaoGeralCustoOperacional = visaoGeralTotal + visaoGeralCustoAdministrativo
    const visaoGeralLucroDesejado = visaoGeralCustoOperacional * ((parseNumericValue(Number(percentuais?.taxaLucro)) || 0) / 100)
    const visaoGeralSubtotalProjeto = visaoGeralCustoOperacional + visaoGeralLucroDesejado

    const propItemValorById = new Map(
      propItens.map((propItem) => [Number(propItem?.propOrcItem_id) || 0, parseNumericValue(Number(propItem?.propOrcItem_valor)) || 0])
    )

    const custoFinanceiroPct = (parseNumericValue(Number(percentuais?.custoFinanceiro)) || 0) / 100
    const contratoMgFin = Array.from(childData?.propOrcsByItem?.entries?.() || []).reduce((acc, [propOrcItemId, propOrcs]) => {
      const valorUnitario = propItemValorById.get(Number(propOrcItemId) || 0) || 0
      const totalItem = (propOrcs || []).reduce((itemAcc, propOrc) => {
        const qtdMes = parseNumericValue(Number(propOrc?.propOrc_qtde)) || 0
        return itemAcc + (qtdMes * valorUnitario)
      }, 0)

      return acc + (totalItem * custoFinanceiroPct)
    }, 0)

    const taxaImpostos = parseNumericValue(Number(percentuais?.taxaImpostos)) || 0
    const taxaComissao = parseNumericValue(Number(percentuais?.taxaComissao)) || 0
    const fatorReceita = 1 - ((taxaImpostos - taxaComissao) / 100)
    const precoFinalProposta = fatorReceita !== 0
      ? (visaoGeralSubtotalProjeto / fatorReceita)
      : 0

    return {
      visaoGeralTotal,
      visaoGeralCustoAdministrativo,
      visaoGeralLucroDesejado,
      contratoMgFin,
      precoFinalProposta,
    }
  }

  handleContratarOrcamento = async (event, sourceProp) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const propId = Number(sourceProp?.prop_id) || 0
    const negociacaoId = Number(sourceProp?.negociacao_id) || 0
    if (!propId) {
      notifyError('Não foi possível identificar a proposta para contratação.')
      return
    }

    const userId = Number(this.props?.auth?.user?.pf_id) || 0

    this.setState((prevState) => ({
      contractingOrcamentosByProp: {
        ...prevState.contractingOrcamentosByProp,
        [propId]: true
      }
    }))

    try {
      const [propostaResumo, childData] = await Promise.all([
        this.fetchPropResumo(propId),
        this.fetchPropChildren(propId),
      ])

      if (!propostaResumo) {
        throw new Error('Proposta não encontrada para contratação.')
      }

      const {
        visaoGeralTotal,
        visaoGeralCustoAdministrativo,
        visaoGeralLucroDesejado,
        contratoMgFin,
      } = this.buildContratoResumo(childData)

      const hoje = moment().format('YYYY-MM-DD')
      const propNome = propostaResumo?.prop_nome || ''

      console.log(propostaResumo)

      const contratoCreated = await oikosApi.post('/', {
        action: 'insert',
        table: 'contrato',
        data: {
          contrato_nome: propNome,
          contrato_contratante: propostaResumo?.pj_id,
          contrato_contratada: 1,
          contrato_vlrGlobal: propostaResumo.prop_valor,
          contrato_dtProp: propostaResumo?.prop_dtCria
            ? moment(propostaResumo.prop_dtCria).format('YYYY-MM-DD')
            : hoje,
          contrato_aguardarOS: 0,
          contrato_fianca: 0,
          contrato_usuarioCria: userId,
          contrato_usuarioMod: userId,
          contrato_dtCria: hoje,
          contrato_dtMod: hoje,
          contratoInst_id: 1,
          contrato_custoDireto: parseNumericValue(Number(propostaResumo?.prop_vlrBaseCustos)) ?? parseNumericValue(Number(visaoGeralTotal)),
          contrato_mgImposto: parseNumericValue(Number(propostaResumo?.prop_vlrImposto)) ??  parseNumericValue(Number(propostaResumo?.prop_vlrImposto)),
          contrato_mgAdm: parseNumericValue(Number(propostaResumo?.prop_vlrAdmin)) ?? parseNumericValue(Number(visaoGeralCustoAdministrativo)),
          contrato_mgFin: parseNumericValue(Number(propostaResumo?.prop_vlrCustoFin)) ?? parseNumericValue(Number(contratoMgFin)),
          contrato_mgLucro: parseNumericValue(Number(propostaResumo?.prop_vlrLucro)) ?? parseNumericValue(Number(visaoGeralLucroDesejado)),
          oport_id: propostaResumo?.bitrix_id || undefined,
          oport_origem: 'bitrix',
          prop_id: propostaResumo?.prop_id || undefined,
        },
      })

      const contratoId = Number(
        contratoCreated?.data?.[0]?.contrato_id ??
        contratoCreated?.data?.contrato_id
      ) || 0

      if (!contratoId) {
        throw new Error('Não foi possível criar o contrato.')
      }

      await fetch(`https://oikos.ecoss.is/oikos/_atualizacaoContratoBitrix.php?deal_id=${propostaResumo?.bitrix_id}&contrato_id=${contratoId}`)

      const contratoProdIdByProdPropId = new Map()
      const contratoEPIdByEventoPagamentoPropId = new Map()

      const prodsDaProposta = childData?.prodsProp || []
      for (let index = 0; index < prodsDaProposta.length; index += 1) {
        const prodProp = prodsDaProposta[index]

        const contratoProdCreated = await oikosApi.post('/', {
          action: 'insert',
          table: 'contratoProd',
          data: {
            contrato_id: contratoId,
            contratoProd_ord: index + 1,
            contratoProd_desc: prodProp?.prodProp_nome,
            contratoProd_prazo: prodProp?.prodProp_prazoEntrega,
            contratoProd_usuarioCria: userId,
            contratoProd_usuarioMod: userId,
            prodProp_id: prodProp?.prodProp_id
          },
        })

        const contratoProdId = Number(
          contratoProdCreated?.data?.[0]?.contratoProd_id ??
          contratoProdCreated?.data?.contratoProd_id
        ) || 0

        const prodPropId = Number(prodProp?.prodProp_id) || 0
        if (contratoProdId && prodPropId) {
          contratoProdIdByProdPropId.set(prodPropId, contratoProdId)
        }
      }

      const eventosDaProposta = childData?.eventosPagamentoProp || []

      let somaDosValoresDosEventos = 0;
      let ajustaValoresDosEventosParaMais = false;
      let ajustaValoresDosEventosParaMenos = false;

      for (let index = 0; index < eventosDaProposta.length; index += 1) {
        const eventoPagamentoProp = eventosDaProposta[index]
        const eventoPct = (parseNumericValue(Number(eventoPagamentoProp?.eventoPagamentoProp_vlr)) || 0) / 100
        console.log(Number((eventoPct * propostaResumo.prop_valor).toFixed(2)))
        somaDosValoresDosEventos += Number((eventoPct * propostaResumo.prop_valor).toFixed(2)) || 0;
      }
      console.log('Soma dos valores dos eventos:', somaDosValoresDosEventos, 'Valor da proposta:', propostaResumo.prop_valor)

      if (Number(Number(somaDosValoresDosEventos).toFixed(2)) < propostaResumo.prop_valor) {
        ajustaValoresDosEventosParaMenos = true;
      }
      if (Number(Number(somaDosValoresDosEventos).toFixed(2)) > propostaResumo.prop_valor) {
        ajustaValoresDosEventosParaMais = true;
      }

      console.log(ajustaValoresDosEventosParaMais, ajustaValoresDosEventosParaMenos)


      for (let index = 0; index < eventosDaProposta.length; index += 1) {
        const eventoPagamentoProp = eventosDaProposta[index]
        const eventoPct = (parseNumericValue(Number(eventoPagamentoProp?.eventoPagamentoProp_vlr)) || 0) / 100

        const contratoEPCreated = await oikosApi.post('/', {
          action: 'insert',
          table: 'contratoEP',
          data: {
            contrato_id: contratoId,
            recTp_id: eventoPagamentoProp?.recTp_id,
            contratoEP_ord: index + 1,
            contratoEP_desc: eventoPagamentoProp?.eventoPagamentoProp_nome,
            contratoEP_prazo: eventoPagamentoProp?.eventoPagamentoProp_prazoPgto,
            contratoEP_vlr: (
              (ajustaValoresDosEventosParaMenos && index === eventosDaProposta.length - 1) ?
              (eventoPct * propostaResumo.prop_valor) - 0.01 :
              (ajustaValoresDosEventosParaMais && index === eventosDaProposta.length - 1) ?
              (eventoPct * propostaResumo.prop_valor) + 0.01 :
              eventoPct * propostaResumo.prop_valor) || 0,
            contratoEP_usuarioCria: userId,
            contratoEP_usuarioMod: userId,
            eventoPagamentoProp_id: eventoPagamentoProp?.eventoPagamentoProp_id
          },
        })

        const contratoEPId = Number(
          contratoEPCreated?.data?.[0]?.contratoEP_id ??
          contratoEPCreated?.data?.contratoEP_id
        ) || 0

        const eventoPagamentoPropId = Number(eventoPagamentoProp?.eventoPagamentoProp_id) || 0
        if (contratoEPId && eventoPagamentoPropId) {
          contratoEPIdByEventoPagamentoPropId.set(eventoPagamentoPropId, contratoEPId)
        }
      }

      const relacoesProdEvento = childData?.relacoes || []
      for (const relacao of relacoesProdEvento) {
        const prodPropId = Number(relacao?.prodProp_id) || 0
        const eventoPagamentoPropId = Number(relacao?.eventoPagamentoProp_id) || 0
        const contratoProdId = contratoProdIdByProdPropId.get(prodPropId) || 0
        const contratoEPId = contratoEPIdByEventoPagamentoPropId.get(eventoPagamentoPropId) || 0

        if (!contratoProdId || !contratoEPId) continue

        await oikosApi.post('/', {
          action: 'update',
          table: 'contratoProd',
          data: {
            contratoProd_id: contratoProdId,
            contratoEP_id: contratoEPId,
            contratoProd_usuarioMod: userId,
          },
        })
      }

      await oikosApi.post('/', {
        action: 'update',
        table: 'prop',
        data: {
          prop_id: propId,
          propStatus_id: 5,
          prop_usuarioMod: userId,
        },
      })

      if (negociacaoId) {
        await this.loadOrcamentosByNegociacao(negociacaoId)
      }

      notifySuccess('Contrato criado com sucesso.')
    } catch (error) {
      console.error('Erro ao contratar proposta', error)
      notifyError('Não foi possível criar o contrato.')
    } finally {
      this.setState((prevState) => ({
        contractingOrcamentosByProp: {
          ...prevState.contractingOrcamentosByProp,
          [propId]: false
        }
      }))
    }
  }

  replicateOrcamento = async (event, sourceProp) => {
    if (event?.stopPropagation) event.stopPropagation()
    if (event?.preventDefault) event.preventDefault()

    const sourcePropId = Number(sourceProp?.prop_id) || 0
    const negociacaoId = Number(sourceProp?.negociacao_id) || 0
    const userId = Number(this.props?.auth?.user?.pf_id) || 0

    if (!sourcePropId || !negociacaoId) {
      notifyError('Não foi possível identificar a proposta a ser replicada.')
      return
    }

    this.setState((prevState) => ({
      cloningOrcamentosByProp: {
        ...prevState.cloningOrcamentosByProp,
        [sourcePropId]: true
      }
    }))

    try {
      const response = await endPoints1Api.post('/', {
        acao: 'replicar_orcamento',
        sourcePropId,
        negociacaoId,
        userId,
      })

      if (response?.data?.ok === false || !Number(response?.data?.prop_id)) {
        throw new Error(response?.data?.detail || response?.data?.message || 'erro_ao_replicar_orcamento')
      }

      await this.loadOrcamentosByNegociacao(negociacaoId)
      notifySuccess('Orçamento replicado com sucesso.')
    } catch (error) {
      console.error('Erro ao replicar orçamento', error)
      const backendDetail = error?.data?.detail || error?.data?.message || error?.message
      notifyError(backendDetail && backendDetail !== 'erro_ao_replicar_orcamento'
        ? backendDetail
        : 'Não foi possível replicar o orçamento.')
    } finally {
      this.setState((prevState) => ({
        cloningOrcamentosByProp: {
          ...prevState.cloningOrcamentosByProp,
          [sourcePropId]: false
        }
      }))
    }
  }

  getModelosPropostaByServico = async (servico_id) => {
    const res = await powerAppsApi.post(
      '/',
      {
        acao: 'get_modelos_proposta',
        servico_id: servico_id
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        }
      }
    )

    const opcoesModelosProposta = Array.isArray(res?.data)
      ? res.data.map((modelo) => ({
          value: modelo.modeloProp_id,
          label: modelo.modeloProp_nome,
          prop_id: modelo.prop_id,
        }))
      : []

    return opcoesModelosProposta;
  }

  renderOrcamentoSection = (rowOriginal) => {
    const negociacaoId = rowOriginal?.negociacao_id;

    const orcamentos = this.state.orcamentosByNegociacao[negociacaoId] || [];
    const isLoadingOrcamentos = !!this.state.loadingOrcamentosByNegociacao[negociacaoId];
    const isSavingServico = !!this.state.savingServicoByNegociacao[negociacaoId];
    const isSavingOrcamento = !!this.state.savingOrcamentosByNegociacao[negociacaoId];
    const isLoadingModelos = !!this.state.loadingModelosByNegociacao[negociacaoId];
    const isCreatingModelo = !!this.state.creatingModeloByNegociacao[negociacaoId];
    const modeloOptions = this.state.modeloOptionsByNegociacao[negociacaoId] || [];
    const selectedServicoId = this.state.selectedServicoByNegociacao[negociacaoId] ?? rowOriginal?.servico_id ?? null;
    const selectedModelo = this.state.selectedModeloByNegociacao[negociacaoId] || null;
    const showModeloSelect = !!this.state.showModeloSelectByNegociacao[negociacaoId];
    return (
      <div style={{ marginTop: '1rem', paddingTop: '0.75rem', borderTop: '1px solid #e9ecef' }}>
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Serviço principal</div>
          <div className="d-flex flex-wrap align-items-center">
            <div style={{ minWidth: 260, flex: '1 1 320px', marginRight: '0.75rem', marginBottom: '0.5rem', zIndex: 3 }}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable
                isSearchable
                value={this.state.servicoOptions.find((option) => option.value === selectedServicoId) || null}
                options={this.state.servicoOptions}
                onChange={(option) => this.handleNegociacaoServicoChange(negociacaoId, option)}
              />
            </div>
            <Button
              size="sm"
              color="primary"
              className="mb-2"
              disabled={isSavingServico}
              onClick={(event) => this.saveNegociacaoServico(event, rowOriginal)}
            >
              {isSavingServico ? 'Salvando...' : 'Salvar'}
            </Button>
          </div>
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Orçamento</div>
          <div className="d-flex flex-wrap align-items-center">
            {
              orcamentos.length === 0 && (
                <Button
                  size="sm"
                  color="primary"
                  outline
                  className="mr-2 mb-2"
                  disabled={isSavingOrcamento}
                  onClick={(event) => {
                    if (!selectedServicoId) {
                      notifyError('Selecione o serviço principal e salve para montar a proposta em branco.')
                      return
                    }
                    this.saveOrcamento(event, negociacaoId, rowOriginal)
                  }}
                >
                  {isSavingOrcamento ? 'Salvando...' : 'Montar proposta em branco'}
                </Button>
              )
            }
            <Button
              size="sm"
              color="primary"
              outline
              className="mr-2 mb-2"
              onClick={() => {
                if (!selectedServicoId) {
                  notifyError('Selecione o serviço principal e salve para criar uma proposta a partir de um modelo.')
                  return
                }
                this.toggleNegociacaoModeloSelect(rowOriginal)
              }}
            >
              Criar proposta a partir de modelo
            </Button>
            {showModeloSelect && (
              <div className="d-flex flex-wrap align-items-center">
                <div style={{ minWidth: 220, marginRight: '0.75rem', marginBottom: '0.5rem', zIndex: 3 }}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable
                    isSearchable={false}
                    isLoading={isLoadingModelos}
                    value={selectedModelo}
                    options={modeloOptions}
                    onChange={(option) => this.handleNegociacaoModeloChange(negociacaoId, option)}
                  />
                </div>
                <Button
                  size="sm"
                  color="primary"
                  outline
                  className="mb-2"
                  disabled={isCreatingModelo || !selectedModelo?.prop_id}
                  onClick={(event) => this.handleCriarPropostaPorModelo(event, rowOriginal)}
                >
                  {isCreatingModelo ? 'Criando...' : 'Criar'}
                </Button>
              </div>
            )}
            {/* <a href={`https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/nova-proposta-em-branco/${rowOriginal.negociacao_id}`} target="_blank" rel="noopener noreferrer">
            </a>

                {/* <Button
                  size="sm"
                  color="primary"
                  outline
                  className="mr-2 mb-2"
                >
                  Nova proposta a partir de modelo
                </Button>
                <a href={`https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/nova-proposta-modelo-proposta/${rowOriginal.negociacao_id}`} target="_blank" rel="noopener noreferrer">
                </a>

                <Button
                  size="sm"
                  color="primary"
                  outline
                  className="mr-2 mb-2"
                >
                  Nova proposta a partir de modelos anteriores com o cliente
                </Button>
                <a href={`https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/nova-proposta-modelo-cliente/${rowOriginal.negociacao_id}`} target="_blank" rel="noopener noreferrer">
                </a> */}
          </div>
        </div>

        <div style={{ marginTop: '0.75rem' }}>
          {isLoadingOrcamentos ? (
            <Spinner size="sm" />
          ) : (
            <MaterialReactTable
              columns={columnsOrcamentoNegociacao({
                onReplicate: (event, propRow) => this.replicateOrcamento(event, {
                  ...propRow,
                  negociacao_id: negociacaoId,
                }),
                onContract: (event, propRow) => this.handleContratarOrcamento(event, {
                  ...propRow,
                  negociacao_id: negociacaoId,
                }),
                onOpenAditivaModal: (event, propRow) => this.openAditivaModal(event, {
                  ...propRow,
                  negociacao_id: negociacaoId,
                  servico_id: selectedServicoId,
                }),
                onStartEditName: (event, propRow) => this.handleStartEditPropNome(event, {
                  ...propRow,
                  negociacao_id: negociacaoId,
                }),
                onChangeEditName: this.handleChangeEditPropNome,
                onSaveEditName: (event, propRow) => this.handleSaveEditPropNome(event, {
                  ...propRow,
                  negociacao_id: negociacaoId,
                }),
                onCancelEditName: this.handleCancelEditPropNome,
                cloningOrcamentosByProp: this.state.cloningOrcamentosByProp,
                contractingOrcamentosByProp: this.state.contractingOrcamentosByProp,
                editingPropNames: this.state.editingPropNames,
                editingDraftPropNames: this.state.editingDraftPropNames,
                savingPropNames: this.state.savingPropNames,
              })}
              data={orcamentos}
              initialState={{
                density: 'compact',
                pagination: { pageIndex: 0, pageSize: 5 },
              }}
              enableGrouping={false}
              enableGlobalFilter={false}
              enableFilters={false}
              enablePagination={orcamentos.length > 5}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableColumnActions={false}
              enableColumnResizing
            />
          )}
        </div>
      </div>
    )
  }

  renderAditivosSection = (rowOriginal) => {
    const negociacaoId = rowOriginal?.negociacao_id
    const aditivos = this.state.aditivosByNegociacao[negociacaoId] || []
    const isLoadingAditivos = !!this.state.loadingAditivosByNegociacao[negociacaoId]

    return (
      <div style={{ marginTop: '1rem', paddingTop: '0.75rem', borderTop: '1px solid #e9ecef' }}>
        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Negociações aditivas</div>
        </div>

        <div style={{ marginTop: '0.75rem' }}>
          {isLoadingAditivos ? (
            <Spinner size="sm" />
          ) : (
            <MaterialReactTable
              columns={columnsAditivosNegociacao}
              data={aditivos}
              initialState={{
                density: 'compact',
                pagination: { pageIndex: 0, pageSize: 5 },
                sorting: [{ id: 'negociacao_id', desc: true }],
              }}
              enableGrouping={false}
              enableGlobalFilter={false}
              enableFilters={false}
              enablePagination={aditivos.length > 5}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableColumnActions={false}
              enableColumnResizing
            />
          )}

          {!isLoadingAditivos && aditivos.length === 0 && (
            <div className="text-muted mt-3">Nenhuma negociação aditiva vinculada a esta negociação.</div>
          )}
        </div>
      </div>
    )
  }

  renderExpandedNegociacaoPanel = (rowOriginal) => {
    const negociacaoId = Number(rowOriginal?.negociacao_id) || 0
    const activeTab = this.state.activeExpandedTabByNegociacao[negociacaoId] || 'propostas'

    return (
      <div style={{ padding: '1rem' }}>
        <p><span style={{fontWeight: 'bold'}}>Nome da negociação:</span> {rowOriginal.negociacao_nome || 'Sem descrição'}</p>
        <p><span style={{fontWeight: 'bold'}}>Cliente:</span> {rowOriginal.pj_nomefanta || 'Sem objeto'}</p>

        <div className="d-flex flex-wrap align-items-center" style={{ gap: '0.5rem', marginTop: '1rem' }}>
          {/* <Button
            size="sm"
            color={activeTab === 'propostas' ? 'primary' : 'light'}
            onClick={() => this.handleExpandedNegociacaoTabChange(negociacaoId, 'propostas')}
          >
            Propostas
          </Button> */}
          {/* <Button
            size="sm"
            color={activeTab === 'aditivos' ? 'primary' : 'light'}
            onClick={() => this.handleExpandedNegociacaoTabChange(negociacaoId, 'aditivos')}
          >
            Aditivos
          </Button> */}
        </div>

        {activeTab === 'aditivos'
          ? this.renderAditivosSection(rowOriginal)
          : this.renderOrcamentoSection(rowOriginal)}
      </div>
    )
  }

  async componentDidMount() {
    const { listProposals, getDraftContracts } = this.props

    /* const allDeals = await this.getListaDealsNegociacao();
    console.log(allDeals);
    this.setState({filteredDeals: allDeals.data, allDeals: allDeals.data})
    listProposals()
    getDraftContracts() */
    const [allNegociacoes] = await Promise.all([
      fetchAllNegociacoes(),
      this.fetchNegociacaoFormOptions(),
    ])
    console.log(allNegociacoes);
    this.setState({
      allNegociacoes: allNegociacoes,
      selectedServicoByNegociacao: this.buildSelectedServicosMap(allNegociacoes),
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.statusFilter?.label !== this.state.statusFilter?.label ||
      prevState.dateFilter !== this.state.dateFilter
    ) {
      this.handleFilter();
    }
  }
  /*
  */

  handleStatusChange = (props) => {
    this.setState({ statusFilter: {value: props.label, label: props.label} });
  };

  handleMonthChange = (e) => {
    this.setState({ dateFilter: e.target.value });
  };

  handleFilter() {
    if (this.state.statusFilter.label !== 'Todas') {
      const filtered = this.state.allDeals.filter((deal) => {
        let dealDate = undefined;
        let dealMonth = undefined;
        if (deal.UF_CRM_1726250379) {
          dealDate = new Date(deal.UF_CRM_1726250379);
        } else if (deal.UF_CRM_1726250379 === undefined){
          dealDate = new Date(deal.contrato_dtAssin);
        }

        if (dealDate) {
          dealMonth = String(dealDate.getMonth() + 1).padStart(2, '0');
        }

        //const resolvedStatus = statusCodeMap[deal.STAGE_ID] || 'unknown';
        const resolvedStatus = statusCodeMap[this.state.statusFilter.label] || 'unknown';

        const matchesStatus = resolvedStatus.includes(deal.STAGE_ID);
        const matchesMonth = !this.state.dateFilter || dealMonth === this.state.dateFilter;

        return matchesStatus && matchesMonth;
      });

      console.log(filtered)

      this.setState({filteredDeals: filtered});
    } else {
      const filtered = this.state.allDeals.filter((deal) => {
        let dealDate = undefined;
        let dealMonth = undefined;
        if (deal.UF_CRM_1726250379) {
          dealDate = new Date(deal.UF_CRM_1726250379);
        } else if (deal.UF_CRM_1726250379 === undefined){
          dealDate = new Date(deal.contrato_dtAssin);
        }

        if (dealDate) {
          dealMonth = String(dealDate.getMonth() + 1).padStart(2, '0');
        }

        const matchesMonth = !this.state.dateFilter || dealMonth === this.state.dateFilter;

        return matchesMonth;
      });

      console.log(filtered)

      this.setState({filteredDeals: filtered});
    }
  }

  getListaDealsNegociacao = async () => {
    const allDeals = await powerAppsApi.post('/',
      {
        acao: 'deals_negociacoes_bitrix',
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        }
      }
    )

    return allDeals.data;
  }

  renderStep = props => {
    const isSelected = props.label === this.state.statusFilter?.label

    return (
      <div
        className="d-flex flex-column flex-grow-1 align-items-center"
        key={props.label}
      >
        <span
          style={{
            fontSize: 12,
            fontWeight: isSelected ? 700 : 500,
            width: 100,
            textAlign: 'center',
            color: isSelected ? 'black' : '#505a62',
            cursor: 'pointer',
          }}
          onClick={(e) => {
            if (props.label !== 'Todas') {
              console.log(props);
              this.handleStatusChange(props)
            } else {
              this.setState({filteredDeals: this.state.allDeals, statusFilter: {value: "Todas", label: "Todas"} })
            }
          }}
        >
          {props.label}
        </span>
        <div
          style={{ width: '100%', height: 30 }}
          className="d-flex flex-row align-items-center"
        >
          <div
            className="d-flex flex-grow-1"
            style={{
              height: 2,
              backgroundColor: '#505a62',
            }}
          />
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: 26,
              height: 26,
              borderRadius: 13,
              border: `2px solid ${isSelected ? 'black' : '#505a62'}`,
              cursor: 'pointer',
            }}
            onClick={(e) => {
            if (props.label !== 'Todas') {
              console.log(props);
              this.handleStatusChange(props)
            } else {
              this.setState({filteredDeals: this.state.allDeals, statusFilter: {value: "Todas", label: "Todas"} })
            }
          }}
          >
            <span
              style={{
                fontWeight: isSelected ? 700 : 500,
                color: isSelected ? 'black' : '#505a62',
                fontSize: 12,
              }}
            >
              {props.count}
            </span>
          </div>
          <div
            className="d-flex flex-grow-1"
            style={{
              height: 2,
              backgroundColor: '#505a62',
            }}
          />
        </div>
        <span
          style={{
            fontSize: 12,
            width: 100,
            textAlign: 'center',
            color: isSelected ? 'black' : '#505a62',
            fontWeight: isSelected ? 700 : 500,
            cursor: 'pointer',
          }}
          onClick={(e) => {
            if (props.label !== 'Todas') {
              console.log(props);
              this.handleStatusChange(props)
            } else {
              this.setState({filteredDeals: this.state.allDeals, statusFilter: {value: "Todas", label: "Todas"} })
            }
          }}
        >
          {props.sum}
        </span>
      </div>
    )
  }

  /*
  renderActionsButton = (proposal) => {
    const status = proposal?.draftContract?.minuta_flowStatus

    switch (status) {
      case 0: return (
        <Button
          disabled
          color="info"
          size="sm"
          outline
          onClick={() => this.setState({
            addDraftContractModalIsOpen: true,
            addDraftContractPreviousData: proposal,
          })}
          title="Aguardando aprovação"
        >
          Minuta em análise
        </Button>
      )

      case 1: return (
        <Button
          color="primary"
          size="sm"
          outline
          onClick={() => this.setState({
            addContractModalIsOpen: true,
            addContractDataDraft: proposal,
          })}
        >
          Cadastrar contrato
        </Button>
      )

      case 2: return (
        <Button
          color="danger"
          size="sm"
          outline
          onClick={() => this.setState({
            addDraftContractModalIsOpen: true,
            addDraftContractPreviousData: proposal,
          })}
          title="Minuta rejeitada"
        >
          Minuta rejeitada
        </Button>
      )

      default: return (
        <Button
          color="primary"
          size="sm"
          outline
          onClick={() => this.setState({
            addDraftContractModalIsOpen: true,
            addDraftContractPreviousData: proposal,
          })}
          title="Cadastrar minuta"
        >
          Cadastrar minuta
        </Button>
      )
    }
  }
  */


  render() {

    const {
      proposals, listProposalsIsLoading,
      draftContracts, getDraftContractsIsLoading,
    } = this.props.comercial

    //const { isManager } = this.props.auth.user

    //if (!isManager) return <Redirect to="/" />

    if (listProposalsIsLoading || getDraftContractsIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    let filteredProposals = []
    let proposalsReduced = []
    // Get statistics
    proposalsReduced = [
      {
        label: 'Todas',
        sum: '',
        count: this.state.allDeals ? this.state.allDeals?.length : 'erro',
      },
    ]
    return (
      <div className="page-content">

      {/*
        <AddContract
          isOpen={addContractModalIsOpen}
          type="private"
          addContractDataDraft={addContractDataDraft}
          toggle={() => {
            this.setState({
              addContractModalIsOpen: false,
              addContractDataDraft: {},
            })

            this.componentDidMount()
          }}
        />

        <AddDraftContract
          isOpen={addDraftContractModalIsOpen}
          addDraftContractPreviousData={addDraftContractPreviousData}
          type="private"
          toggle={() => {
            this.setState({
              addDraftContractModalIsOpen: false,
              addDraftContractPreviousData: {},
            })

            this.componentDidMount()
          }}
        />
      */}


        <Container fluid>
          <Breadcrumbs
            title="Negociações"
            breadcrumbItems={[]}
          />

          {/* <Row className="mb-3">

            <Col xl={2} lg={3} md={4} sm={4}>
              <Select
                isClearable
                placeholder="Período..."
                options={[
                  {
                    value: '01',
                    label: 'Janeiro',
                  },
                  {
                    value: '02',
                    label: 'Fevereiro',
                  },
                  {
                    value: '03',
                    label: 'Março',
                  },
                  {
                    value: '04',
                    label: 'Abril',
                  },
                  {
                    value: '05',
                    label: 'Maio',
                  },
                  {
                    value: '06',
                    label: 'Junho',
                  },
                  {
                    value: '07',
                    label: 'Julho',
                  },
                  {
                    value: '08',
                    label: 'Agosto',
                  },
                  {
                    value: '09',
                    label: 'Setembro',
                  },
                  {
                    value: '10',
                    label: 'Outubro',
                  },
                  {
                    value: '11',
                    label: 'Novembro',
                  },
                  {
                    value: '12',
                    label: 'Dezembro',
                  },
                ]}
                onChange={selected => this.setState({ dateFilter: selected?.value || null })}
              />
            </Col>
          </Row>

          {proposalsReduced && proposalsReduced.length > 0 && (
            <Row className="ml-0 mr-0 mb-4 mt-4">
              {proposalsReduced.map(i => {
                return ( this.renderStep({ label: i.label, count: i.count, sum: i.sum }))
              })}
            </Row>
          )} */}

          <Modal size='lg' isOpen={this.state.addNegociacaoModalIsOpen} toggle={this.closeAddNegociacaoModal}>
            <ModalHeader toggle={this.closeAddNegociacaoModal}>Nova negociação</ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label>Nome da negociação</Label>
                <Input
                  value={this.state.novaNegociacaoData.negociacao_nome}
                  onChange={(event) => this.handleNovaNegociacaoChange('negociacao_nome', event.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Prazo limite</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  selected={this.state.novaNegociacaoData.negociacao_prazo}
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => this.handleNovaNegociacaoChange('negociacao_prazo', date)}
                />
              </FormGroup>
              <FormGroup>
                <Label>ID do Bitrix</Label>
                <Input
                  type="number"
                  value={this.state.novaNegociacaoData.bitrix_id}
                  onChange={(event) => this.handleNovaNegociacaoChange('bitrix_id', event.target.value)}
                  onWheel={(e)=>{e.target.blur()}}
                />
              </FormGroup>
              <FormGroup>
                <Label>Objeto</Label><br />
                <TextareaAutosize
                  style={{width: "100%", height: "100px"}}
                  value={this.state.novaNegociacaoData.negociacao_obj}
                  onChange={(event) => this.handleNovaNegociacaoChange('negociacao_obj', event.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Pessoa Jurídica</Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable
                  isSearchable
                  value={this.state.pjOptions.find((option) => option.value === this.state.novaNegociacaoData.pj_id) || null}
                  options={this.state.pjOptions}
                  onChange={(option) => this.handleNovaNegociacaoChange('pj_id', option?.value || null)}
                />
              </FormGroup>
              {/* <FormGroup>
                <Label>Área de atuação</Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable
                  isSearchable
                  value={this.state.areaAtuaOptions.find((option) => option.value === this.state.novaNegociacaoData.areaAtua_id) || null}
                  options={this.state.areaAtuaOptions}
                  onChange={(option) => this.handleNovaNegociacaoChange('areaAtua_id', option?.value || null)}
                />
              </FormGroup> */}
              <FormGroup>
                <Label>Código tributário</Label>
                <Input
                  value={this.state.novaNegociacaoData.negociacao_codTrib}
                  onChange={(event) => this.handleNovaNegociacaoChange('negociacao_codTrib', event.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Serviço principal</Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable
                  isSearchable
                  value={this.state.servicoOptions.find((option) => option.value === this.state.novaNegociacaoData.servico_id) || null}
                  options={this.state.servicoOptions}
                  onChange={(option) => this.handleNovaNegociacaoChange('servico_id', option?.value || null)}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" outline onClick={this.closeAddNegociacaoModal}>
                Cancelar
              </Button>
              <Button color="primary" onClick={this.saveNegociacao} disabled={this.state.isSavingNegociacao}>
                {this.state.isSavingNegociacao ? 'Salvando...' : 'Criar negociação'}
              </Button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.additivaModalIsOpen} toggle={this.closeAditivaModal}>
            <ModalHeader toggle={this.closeAditivaModal}>Montar proposta aditiva</ModalHeader>
            <ModalBody>
              <div className="d-flex flex-column">
                <Button
                  color="primary"
                  outline
                  className="mb-2"
                  disabled={!!this.state.savingOrcamentosByNegociacao[Number(this.state.additivaModalSourceProp?.negociacao_id) || 0]}
                  onClick={this.handleCriarPropostaAditivaEmBranco}
                >
                  {!!this.state.savingOrcamentosByNegociacao[Number(this.state.additivaModalSourceProp?.negociacao_id) || 0]
                    ? 'Salvando...'
                    : 'Montar proposta em branco'}
                </Button>
                <Button
                  color="primary"
                  outline
                  className="mb-2"
                  onClick={this.handleOpenAditivaModeloFlow}
                >
                  Montar a partir de modelo
                </Button>
                <Button
                  color="primary"
                  outline
                  className="mb-3"
                  onClick={this.handleCriarPropostaAditivaOriginal}
                >
                  Montar proposta a partir da proposta original
                </Button>

                {this.state.additivaModalShowModeloSelect && (() => {
                  const negociacaoId = Number(this.state.additivaModalSourceProp?.negociacao_id) || 0
                  const isLoadingModelos = !!this.state.loadingModelosByNegociacao[negociacaoId]
                  const isCreatingModelo = !!this.state.creatingModeloByNegociacao[negociacaoId]
                  const modeloOptions = this.state.modeloOptionsByNegociacao[negociacaoId] || []
                  const selectedModelo = this.state.selectedModeloByNegociacao[negociacaoId] || null

                  return (
                    <div className="d-flex flex-wrap align-items-center">
                      <div style={{ minWidth: 220, flex: '1 1 280px', marginRight: '0.75rem', marginBottom: '0.5rem', zIndex: 3 }}>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable
                          isSearchable={false}
                          isLoading={isLoadingModelos}
                          value={selectedModelo}
                          options={modeloOptions}
                          onChange={(option) => this.handleNegociacaoModeloChange(negociacaoId, option)}
                        />
                      </div>
                      <Button
                        color="primary"
                        outline
                        className="mb-2"
                        disabled={isCreatingModelo || !selectedModelo?.prop_id}
                        onClick={this.handleCriarPropostaAditivaPorModelo}
                      >
                        {isCreatingModelo ? 'Criando...' : 'Criar'}
                      </Button>
                    </div>
                  )
                })()}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" outline onClick={this.closeAditivaModal}>
                Fechar
              </Button>
            </ModalFooter>
          </Modal>

          {this.state.allNegociacoes && <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-3">
                    <Button color="primary" onClick={this.openAddNegociacaoModal}>
                      Nova negociação
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsNegociacao}
                    data={this.state.allNegociacoes}
                    getRowId={(row) => String(row.negociacao_id)}
                    initialState={{
                      density: 'compact',
                      expanded: false, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 20 },
                      sorting: [], //sort by state by default
                    }}
                    state={{ expanded: this.state.expandedNegociacoes }}
                    onExpandedChange={this.handleExpandedNegociacoesChange}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={true}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [10, 20, 50, 100],
                    }}
                    enableColumnResizing
                    enableTopToolbar={false}
                    enableRowExpansion={true}
                    renderDetailPanel={({ row }) => {
                      if(row.original.negociacao_nome) {
                        return this.renderExpandedNegociacaoPanel(row.original)
                      }
                    }}
                  />
                  {/*
                  <MaterialReactTable
                    columns={columns}
                    data={this.state.filteredDeals}
                    initialState={{
                      density: 'compact',
                      expanded: false, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 20 },
                      sorting: [], //sort by state by default
                    }}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={true}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [10, 20, 50, 100],
                    }}
                    enableTopToolbar={false}
                    enableRowExpansion={true}
                    renderDetailPanel={({ row }) => {
                      if(row.original.TITLE) {
                        return (
                          <div style={{ padding: '1rem' }}>
                            <p><span style={{fontWeight: 'bold'}}>Descrição:</span> {row.original.TITLE || 'Sem descrição'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Objeto:</span> {row.original.UF_CRM_1709295573 || 'Sem objeto'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Data do envio da proposta:</span> {row.original.UF_CRM_1726250379 ? moment(row.original.UF_CRM_1726250379).format('DD/MM/YYYY') : 'Sem data'}</p>
                            <p><a style={{fontWeight: 'bold'}} target='_blank' href={`https://ecossis.bitrix24.com.br/crm/deal/details/${row.original.ID}/`}>Bitrix</a></p>
                            {this.renderOrcamentoSection(row.original)}
                          </div>
                        )
                      } else if (row.original.contrato_id) {
                        return (
                          <div style={{ padding: '1rem' }}>
                            <p><span style={{fontWeight: 'bold'}}>Descrição:</span> {row.original.contrato_nome || 'Sem descrição'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Objeto:</span> {row.original.contrato_obj || 'Sem objeto'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Cliente:</span> {row.original.pj_nomefanta || 'Cliente não registrado'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Email do cliente:</span> {row.original.pj_emailPrin || 'Email não registrado'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Telefone do cliente:</span> {row.original.pj_telPrin || 'Telefone não registrado'}</p>
                            <p><span style={{fontWeight: 'bold'}}>Data de assinatura:</span> {row.original.contrato_dtAssin ? moment(row.original.contrato_dtAssin).format('DD/MM/YYYY') : 'Sem data'}</p>
                            <p><a style={{fontWeight: 'bold'}} target='_blank' href={`https://oikos.ecoss.is/oikos-client/comercial/contratos/${row.original.contrato_id}`}>Contrato</a></p>
                            {this.renderOrcamentoSection(row.original)}
                          </div>
                        )
                      }
                    }}
                  />
                  <DataTable
                    data={{
                      columns: [
                        {
                          label: 'Nome',
                          field: 'name',
                          sort: 'disabled',
                        },
                        {
                          label: 'Valor',
                          field: 'value',
                          sort: 'disabled',
                        },
                        {
                          label: 'Status',
                          field: 'status',
                          sort: 'disabled',
                        },
                      ],
                      rows:
                      this.state.filteredDeals ? this.state.filteredDeals.map(proposal => ({
                        name: proposal.TITLE ? proposal.TITLE : proposal.contrato_nome,
                        value: proposal.TITLE ? currencyFormatter.format(proposal.OPPORTUNITY) : currencyFormatter.format(proposal.contrato_vlrGlobal),
                        status: this.formatStatus(proposal.STAGE_ID),
                      })) : [],
                    }}
                  />
                  */}
                </CardBody>
              </Card>
            </Col>
          </Row>}

        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  listProposals,
  getDraftContracts,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Acompanhamento)
